import React, { useEffect, useRef, useState } from "react";

import styles from "styles.module.css";

import Filter from "./Filter";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";

// import "./styles.css";
import { addMonths } from "date-fns";
import OverLayLoading from "ui/Loading";
import { useTranslation } from "react-i18next";

import { Loading } from "ui/Loading";
import { usePageAccess } from "hooks/usePageAccess";
import { landingNoteJournalGridColumns } from "./GridColumns";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
import {
	getLandingNoteJournalApi,
	LandingNoteJournalFilter,
} from "api/landingNoteoJournal";

const pageSize = 60;

const LandingNoteJournal = () => {
	const { t } = useTranslation();

	const overlayRef = useRef<HTMLDivElement>(null);

	const gridRef = useRef<HTMLDivElement>(null);
	const [filterOptions, setFilterOptions] = useState<LandingNoteJournalFilter>({
		fromDate: addMonths(new Date(), -1),
		toDate: new Date(),
	});

	const pdfRef = useRef<GridPDFExport>(null);
	const excelRef = useRef<ExcelExport>(null);

	const { pageAccess, loading } = usePageAccess();

	const exportGridAsPDF = () => {
		if (pdfRef.current !== null) {
			pdfRef.current.save();
		}
	};

	const exportGridAsExcel = () => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	};

	if (!pageAccess) {
		return <Loading show={true} />;
	}

	return (
		<div className={styles.PageContainer}>
			<div ref={overlayRef} style={{ display: "none" }}>
				<OverLayLoading />
			</div>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>
					{t("LandingNoteJournal")}
				</legend>
			</div>

			<div>
				<Filter
					setFilterOptions={setFilterOptions}
					filterOptions={filterOptions}
					exportAsPDF={exportGridAsPDF}
					exportAsExcel={exportGridAsExcel}
					pageSize={pageSize}
				/>
			</div>
			<div style={{}} ref={gridRef}>
				<div style={{ marginTop: 30 }} ref={gridRef}>
					<GridWithGroupPaging
						apiMethod={getLandingNoteJournalApi}
						gridColumns={landingNoteJournalGridColumns()}
						pageable={false}
						group={[
							{
								field: "receiverName",
								aggregates: [
									{
										field: "grossWeight",
										aggregate: "sum",
									},
								],
							},
						]}
						groupable={{ footer: "visible", enabled: false }}
						filter={filterOptions}
						// className="opened-statistics-grid"
						exportGridAsExcelRef={excelRef}
						// groupHeaderCell={GroupHeaderCellGrossWeight}
						// aggregateFields={aggregatesFields}
						// groupLargeColumn={[
						// 	{ field: "grossWeight", width: 270 },
						// 	{ field: "buyerPrice", width: 270 },
						// ]}
					/>
				</div>
			</div>
		</div>
	);
};

export default LandingNoteJournal;
